<template>
  <div>
    <NGNDetailModal
      :show="showNGNModal"
      :toggle="toggleNGNModal"
      :singleNGNObj="singleNGNObj"
      :refetch="refetch"
    />
    <div class="px-3">
      <FilterWrapper>
        <template slot="filterForm">
          <GenericFilter
            :loading="loading"
            :rLoading="rLoading"
            :submitFilter="refetch"
            :clearFilter="() => clearFilter('merchantCustomerRef')"
          />
        </template>
      </FilterWrapper>
    </div>
    <TableWrapper
      :loading="loading"
      :errorMsg="errorMsg"
      :refetch="fetchCurrencyWallet"
      :isEmpty="isEmpty"
      :emptyTitle="emptyTitle"
    >
      <div class="w-100 py-3" slot="content">
        <v-server-table
          ref="merchantCustomerRef"
          class="v-table row-pointer"
          :data="customers"
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
          @loading="setLoading(true)"
          @row-click="handleClick"
        >
          <template slot="createdAt" slot-scope="{ row }">
            {{ row.createdAt | moment(" MM-DD-YYYY h:mm a") }}
          </template>
          <template slot="amount" slot-scope="{ row }">
            {{ toCurrency(row.amount, row.currency) }}
          </template>
          <div slot="action" slot-scope="{ row }">
            <span class="badge badge-app">
              {{ row.action === "credit" ? "Credit" : "Debit" }} </span
            ><span
              ><img
                v-if="row.action === 'debit'"
                src="/assets/img/icons/import.svg"
                alt=""
              />
              <img v-else src="/assets/img/icons/export.svg" alt="" />
            </span>
          </div>
        </v-server-table>
      </div>
    </TableWrapper>
  </div>
</template>

<script>
import { componentData } from "../../../../../public/assets/mixins/componentData";
import TableWrapper from "../../../../components/utils/TableWrapper/TableWrapper.vue";
import GenericFilter from "../../../../components/filters/GenericFilter.vue";
import NGNDetailModal from "../../../../views/Customers/modals/NGNDetailModal";

const tableHeadings = {
  reference: "Transaction Reference",
  amount: "Amount",
  "Wallet.account_number": "Account Number",
  "Wallet.account_name": "Sender",
  action: "Type",
  createdAt: "Date",
};

export default {
  name: "NGNWallet",
  mixins: [componentData],
  data() {
    return {
      singleNGNObj: null,
      showNGNModal: false,
      emptyTitle: "No Wallet Found",
      loading: false,
      errorMsg: "",
      customers: [],
      ...this.tableOptions(tableHeadings, 25),
    };
  },
  components: {
    GenericFilter,
    TableWrapper,
    NGNDetailModal,
  },
  methods: {
    toggleNGNModal() {
      this.showNGNModal = !this.showNGNModal;
    },
    refetch(filters) {
      this.handleRefetch(
        filters,
        this.fetchCurrencyWallet,
        "merchantCustomerRef"
      );
    },
    handleClick({ row }) {
      //   this.$router.push(`/customer/${row.client_id}`);
      this.singleNGNObj = row;
      this.showNGNModal = true;
    },
    async fetchCurrencyWallet() {
      this.options.requestFunction = async (data) => {
        const params = {
          ...data,
          ...this.filters,
          id: this.clientid,
          wallet: this.$route.params.ref,
          size: 25
        };
        const response = await this.$store.dispatch(
          "customer/getPaymentMerchantTransactions",
          {
            params,
          }
        );

        const newData = response.data.data;
        const count = response.data.count;
        return { ...response, count, total: count, data: newData };
      };
    },
    refetch(filters) {
      this.handleRefetch(
        filters,
        this.fetchCurrencyWallet,
        "merchantCustomerRef"
      );
    },
  },

  props: ["clientid"],
  created() {
    this.fetchCurrencyWallet();
  },
  mounted() {
    this.columns = Object.keys(tableHeadings).map((keyVal) => keyVal);
  },
};
</script>
